'use client';

import { mergeClasses } from 'minimal-shared/utils';

import { styled } from '@mui/material/styles';

import { svgColorClasses } from './classes';

// ----------------------------------------------------------------------

export type SvgColorProps = {
  src?: string;
  className?: string;
  sx?: any;
} & Record<string, any>;

export function SvgColor({ src, className, sx, ...other }: SvgColorProps) {
  return (
    <SvgRoot
      className={mergeClasses([svgColorClasses.root, className])}
      sx={[
        {
          mask: `url(${src}) no-repeat center / contain`,
          WebkitMask: `url(${src}) no-repeat center / contain`,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    />
  );
}

// ----------------------------------------------------------------------

const SvgRoot = styled('span', {
  shouldForwardProp: (prop: string) => prop !== 'sx',
})(() => ({
  width: 24, // 기본값
  height: 24, // 기본값
  flexShrink: 0,
  display: 'inline-flex',
  backgroundColor: 'currentColor',
}));
